import firestore from "./../../config/firebase";
import firebase from "firebase";

/**
 * UploadImage()
 * upload the image to fireStorage
 * Method : PUT
 */
export const UploadImage = model => {
  const filename = model.name;
  return firebase
    .storage()
    .ref("SummerNoteUploads/" + filename)
    .put(model);
};

/**
 * Set Total image count to be upload in the localstorage
 */

export const SetTotalImageCount = count => {
  if (!localStorage.getItem("TotalImageCount")) {
    localStorage.setItem("TotalImageCount", 0);
  }

  let imageCount = localStorage.getItem("TotalImageCount")
    ? localStorage.getItem("TotalImageCount")
    : 0;

  if (count == 0) {
    imageCount = 0;
  } else {
    imageCount = parseInt(imageCount) + parseInt(count);
  }
  localStorage.setItem("TotalImageCount", imageCount);
};

/**
 * Set Uploaded image count in the localstorage
 */
export const SetUploadedImageCount = count => {
  if (!localStorage.getItem("UploadedImageCount")) {
    localStorage.setItem("UploadedImageCount", 0);
  }

  let imageCount = localStorage.getItem("UploadedImageCount")
    ? localStorage.getItem("UploadedImageCount")
    : 0;

  if (count == 0) {
    imageCount = 0;
  } else {
    imageCount = parseInt(imageCount) + parseInt(count);
  }
  localStorage.setItem("UploadedImageCount", imageCount);
};

/**
 * Get Total image count to be upload from the localstorage
 */
export const GetTotalImageCount = () => {
  let imageCount = localStorage.getItem("TotalImageCount")
    ? parseInt(localStorage.getItem("TotalImageCount"))
    : {};

  return imageCount;
};

/**
 * Get Uploaded image count from the localstorage
 */
export const GetUploadedImageCount = () => {
  let imageCount = localStorage.getItem("UploadedImageCount")
    ? parseInt(localStorage.getItem("UploadedImageCount"))
    : {};

  return imageCount;
};
